import { getFormData } from "../../../common";
import { deleteFrontYard, updateFrontYard } from "../../../repository/RealEstateRepository";

const FrontYardDetail = (props) => {
  const { detail } = props;

  const onClickEdit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target.form);
    updateFrontYard(formData, () => {
      window.Toast.info("UPDATED!");
    });
  };

  const onClickDelete = (e) => {
    e.preventDefault();
    const answer = window.confirm("Are you sure?");
    if (answer) {
      deleteFrontYard({ id: detail.id }, () => {
        props.history.push("/realestate/frontyard");
      });
    }
  };

  return (<>
    <form>
      <div className="row">
        <div className="col-3 col-sm-3"></div>
        <div className="col-12 col-sm-6 form-group text-left">
          <label>Name</label>
          <input type="hidden" name="id" className="form-control fluid" defaultValue={detail.id} readOnly={true} />
          <input type="text" name="name" className="form-control fluid" defaultValue={detail.name} />
        </div>
      </div>

      <div className="row">
        <div className="col-3 col-sm-3"></div>
        <div className="col-12 col-sm-6 form-group text-left">
          <label>Population</label>
          <input type="text" name="population" className="form-control fluid" defaultValue={detail.population | 0} placeholder="population" />
        </div>
      </div>

      <div className="row">
        <div className="col-3 col-sm-3"></div>
        <div className="col-12 col-sm-6 form-group text-left">
          <label>Employee</label>
          <input type="text" name="numberOfEmployees" className="form-control fluid" defaultValue={detail.numberOfEmployees | 0} placeholder="numberOfEmployees" />
          <input type="text" name="numberOfEmployeesAtMajorCompany" className="form-control fluid" defaultValue={detail.numberOfEmployeesAtMajorCompany | 0} placeholder="numberOfEmployeesAtMajorCompany" />
        </div>
      </div>

      <div className="row">
        <div className="col-3 col-sm-3"></div>
        <div className="col-12 col-sm-6 form-group text-left">
          <label>Company</label>
          <input type="text" name="companyCount" className="form-control fluid" defaultValue={detail.companyCount | 0} placeholder="companyCount" />
          <input type="text" name="majorCompanyCount" className="form-control fluid" defaultValue={detail.majorCompanyCount | 0} placeholder="majorCompanyCount" />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <button className="btn btn-danger" onClick={onClickDelete}>Remove</button>
          &nbsp;<button className="btn btn-primary" onClick={onClickEdit}>Update</button>
        </div>
      </div>
    </form>
  </>);
};

export { FrontYardDetail };
